import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import ContactUs from "./pages/contact-us/ContactUs";
import Gallery from "./pages/gallery/Gallery";
import Blog from "./pages/blog/Blog";
import About from "./pages/about/About";
import Faq from "./pages/faq/Faq";
import Physiotherapy from "./pages/services/Physiotherapy";
import OurDoctor from "./pages/ourdoctor/OurDoctor";
import GeneralMedicine from "./pages/services/GeneralMedicine";
import GeneralSurgery from "./pages/services/GeneralSurgery";
import Gynaecology from "./pages/services/Gynaecology";
import Orthopedic from "./pages/services/Orthopedic";
import Paediatrics from "./pages/services/Paediatrics";
import Dental from "./pages/services/Dental";
import ENT from "./pages/services/ENT";
import Pulmonology from "./pages/services/Pulmonology";
import Dermatology from "./pages/services/Dermatology";
import Urology from "./pages/services/Urology";
import Anaesthesiology from "./pages/services/Anaesthesiology";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/our-doctor" element={<OurDoctor />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/orthopedic" element={<Orthopedic />} />
            <Route path="/general-surgery" element={<GeneralSurgery />} />
            <Route path="/general-medicine" element={<GeneralMedicine />} />
            <Route path="/dental" element={<Dental />} />
            <Route path="/gynaecology" element={<Gynaecology />} />
            <Route path="/paediatrics" element={<Paediatrics />} />
            <Route path="/ent" element={<ENT />} />
            <Route path="/pulmonology" element={<Pulmonology />} />
            <Route path="/dermatology" element={<Dermatology />} />
            <Route path="/urology" element={<Urology />} />
            <Route path="/anaesthesiology" element={<Anaesthesiology />} />
            <Route path="/physiotherapy" element={<Physiotherapy />} />
            
           
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
